import axios from "@/utils/http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块
const uploadImgUrl = process.env.VUE_APP_UPLOADIMG_API;

const ad = {
  // 经销商登录
  logins(code) {
    return axios.post("/auth/login", qs.stringify({ code: code }));
  },
  // 经销商登录
  login(data) {
    return axios.post("/auth/login/password", data);
  },
  // 图片上传
  uploadImg(data) {
    return axios.post(`${uploadImgUrl}`, data);
  },
  // 新增广告申请
  adApply(params) {
    return axios.post("/advert-apply/apply", params);
  },
  // 门店第一次确认
  firstConfirm(data) {
    return axios.post("/advert-apply/first-confirm", data);
  },
  // 门店再次确认
  reconfirm(data) {
    return axios.post("/advert-apply/reconfirm", data);
  },
  // 门店详情
  adDetails(id) {
    return axios.get(`/advert-apply/${id}`);
  },
  // 微信签名
  weiXingSDK(url) {
    return axios.get(`/wx/wxJsapiSignature?url=${url}`).then(res => {
      return res.result;
    });
  },
  // 申请记录
  applyList(type) {
    return axios.get(`/advert-apply/list?subReimbursed=${type}`);
  },
  // 获取进货凭证 已废除
  getCertificate(id) {
    return axios.get(`/advert-apply/get_purchase_certificate/${id}`);
  },

  // // 获取进货凭证
  // getCertificate(id) {
  //   return axios.get(`/advert-apply/attachments/${id}`);
  // },

  // 上传进货凭证
  certificate(params) {
    return axios.post("/advert-apply/upload_purchase_certificate", params);
  },
  // 上传进货凭证
  submitReimburs(data) {
    return axios.post("/advert-apply/submitReimburs", data);
  },
  // 重发短信
  resendMessage(id) {
    return axios.post(`/advert-apply/sendFirstConfirmSms?advertApplyId=${id}`);
  }
};

export default ad;
